<template>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>奖励编辑器</span>
        </div>
        <el-form label-position="left">
            <el-form-item label="大类:">
                <el-select v-model="optionValue" placeholder='请选择'>
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="必要资源编号:" v-if="optionValue == '0'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr0" :key="item.id" :label="item.id+'-'+$t(item.name)" :value="item.id">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>

            </el-form-item>

            <el-form-item label="怪兽编号:" v-if="optionValue == '1'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in monsterConfigs" :key="item.id" :label="item.id +'-' + $t(item.name)"
                        :value="item.id">
                        <el-image style="width: 30px; height: 30px; float: left" :src="'./static/monster_icon/'+item.id+'.png'"
                            fit="cover"></el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="怪兽碎片编号:" v-if="optionValue == '2'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in monsterConfigs" :key="item.id + 10000" :label="(item.id + 10000) +'-' + $t(item.name) + '碎片'"
                        :value="item.id + 10000">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 10000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) + '碎片' }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="怪兽觉醒水晶编号:" v-if="optionValue == '6'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr5" :key="item.id + 20000" :label="(item.id + 20000) +'-' + $t(item.name) + '觉醒结晶'"
                        :value="item.id + 20000">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 20000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) + '觉醒结晶' }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="怪兽觉醒水晶碎片编号:" v-if="optionValue == '8'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr5" :key="item.id + 30000" :label="(item.id + 30000) +'-' + $t(item.name) + '觉醒结晶碎片'"
                        :value="item.id + 30000">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 30000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) + '觉醒结晶碎片' }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="道具编号:" v-if="optionValue == '3'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr3" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="元核编辑:" v-if="optionValue == '4'">
                <el-select v-model="value" filterable placeholder='请选择' @change="onEmblemTypeChange">
                    <el-option v-for="item in arrProp4" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                    </el-option>
                </el-select>
                <div v-if="!emblemRandomByQuality">
                    <el-divider></el-divider>
                    <el-row>
                        <!--主属性-->
                        <el-col :lg="8">
                            <div>主属性:</div>
                        </el-col>
                        <el-col>
                            <el-select v-model="emblemMainProperty" filterable default-first-option placeholder='请选择' value="">
                                <el-option v-for="item in emblemMainConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <!--品质-->
                        <el-col :lg="8"><div>品质:</div></el-col>
                        <el-col>
                            <el-select v-model="emblemQuality" filterable default-first-option placeholder='请选择' value="" @change="onEmblemQualityChange">
                                <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-divider></el-divider>
                    <el-row>
                        <!--等级-->
                        <el-col :lg="4">
                            <div>等级:
                                <el-input-number v-model="emblemLevel" :min="1" :max="150" label="选择元核等级" @change="onEmblemLevelChange"></el-input-number>
                            </div>
                        </el-col>
                        <!--阶段-->
                        <el-col :lg="4">
                            <div>阶段:
                                <el-input-number v-model="emblemStage" :min="0" :max="20" :disabled="true" label="选择元核阶段"></el-input-number>
                            </div>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <!--宿命-->
                    <div>宿命：</div>
                    <div>
                        <el-select v-model="emblemFate" filterable default-first-option placeholder='请选择' value="">
                            <el-option v-for="item in emblemFateOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if="emblemFate===2">
                        <el-select v-model="emblemFateProperty" filterable placeholder='请选择' value="">
                            <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if="emblemFate===3">
                        <el-row>
                            <el-col>
                                宿命出现概率(百分比):
                            </el-col>
                            <el-col :lg="12">
                                <el-slider
                                    v-model="emblemFateCustomize"
                                    show-input input-size="mini">
                                </el-slider>
                            </el-col>
                            <el-col>
                                <div class="block">
                                    <div>
                                        <el-col>
                                            选择宿命效果:
                                        </el-col>
                                        <el-select v-model="editEmblemFateProperty" filterable placeholder='请选择' value="">
                                            <el-option v-for="item in emblemFateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <el-col>
                                            配置权重:
                                        </el-col>
                                        <el-input-number v-model="editEmblemFateChance" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                                    </div>
                                    <div>
                                        <el-col>
                                            指定宿命品质:
                                        </el-col>
                                        <el-select v-model="editEmblemFateQuality" filterable placeholder='请选择' value=0>
                                            <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <el-col>
                                            指定浮动值:
                                        </el-col>
                                        <el-input-number v-model="editEmblemFateRdFloat" filterable :step="0.01" placeholder='请选择' value=0></el-input-number>
                                    </div>
                                    <el-button @click="addEmblemFateChance">添加权重</el-button>
                                    <el-row>
                                        <el-col>
                                            结果集:
                                        </el-col>
                                        <el-tag v-for="(tag,idx) in emblemFateCustomizeTags" :key="idx" closable @close="deleteEmblemFateChance(idx)">{{$t(tag.data.name)}}-{{tag.chance}}-{{tag.quality}}-{{tag.rdFloat}}</el-tag>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                    <!--词条-->
                    <div>词条：</div>
                    <!--                    <div>
                                            <el-row>
                                                <el-col>
                                                    <el-button @click="addEmblemEntry">{{$t('reward_editor.15')}}</el-button>
                                                    <el-button @click="removeEmblemEntry">{{$t('reward_editor.16')}}</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>-->
                    <div v-if="editEmblemEntries[0].active===true">
                        <el-row>
                            <el-col>词条1：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[0].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[0].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[0].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[1].active===true">
                        <el-row>
                            <el-col>词条2：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[1].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[1].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[1].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[2].active===true">
                        <el-row>
                            <el-col>词条3：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[2].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[2].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[2].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[3].active===true">
                        <el-row>
                            <el-col>词条4：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[3].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[3].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[3].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[4].active===true">
                        <el-row>
                            <el-col>词条5：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[4].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[4].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[4].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <div v-if="editEmblemEntries[5].active===true">
                        <el-row>
                            <el-col>词条6：</el-col>
                        </el-row>
                        <el-row>
                            <el-col :lg="7">
                                词条效果：
                                <el-cascader v-model="editEmblemEntries[5].entry" :options="emblemEntryConfigs">
                                    <template slot-scope="{ node, data }">
                                        <span>{{ data.label }}</span>
                                        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                                    </template>
                                </el-cascader>
                            </el-col>
                            <el-col :lg="7">
                                词条品质：
                                <el-select v-model="editEmblemEntries[5].quality" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in emblemQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :lg="5">
                                浮动值：
                                <el-input-number v-model="editEmblemEntries[5].rdFloat" filterable :step="0.01" placeholder='请选择' value=0>
                                </el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                    <el-divider></el-divider>
                </div>
            </el-form-item>

            <template v-if="optionValue === '7'">
                <el-form-item label="战纹编号:" >
                    <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                        <el-option v-for="item in arr7" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="战纹品质:">
                    <el-select v-model="warGrooveQuality" filterable default-first-option placeholder='请选择'>
                        <el-option v-for="item in wallGainQualityConfig" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                        </el-option>
                    </el-select>
                    <div>
                        <el-switch v-model="warGrooveChannelSwitch" active-text='固定通路' inactive-text='随机通路'>
                        </el-switch>

                        <div v-if="warGrooveChannelSwitch">
                            <div>
                                <span>上：</span>
                                <el-select v-model="warGrooveChannelUp" filterable default-first-option placeholder='请选择'>
                                    <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <span>下：</span>
                                <el-select v-model="warGrooveChannelDown" filterable default-first-option placeholder='请选择'>
                                    <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <span>左：</span>
                                <el-select v-model="warGrooveChannelLeft" filterable default-first-option placeholder='请选择'>
                                    <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div>
                                <span>右：</span>
                                <el-select v-model="warGrooveChannelRight" filterable default-first-option placeholder='请选择'>
                                    <el-option v-for="item in warGrooveChannelOption" :key="item.id" :label="(item.id ) +'-' +$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </template>


            <el-form-item label="部落公共资源编号:" v-if="optionValue === '9'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr9" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="回复类道具编号:" v-if="optionValue === '10'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr10" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="头像:" v-if="optionValue === '11'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr11" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="头像框:" v-if="optionValue === '12'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr12" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="宝箱:" v-if="optionValue === '13'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr13" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="皮肤:" v-if="optionValue === '14'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr14" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="时效类道具:" v-if="optionValue === '15'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr15" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">

                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>

                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item  label="起源盘:" v-if="optionValue === '17'">
                    <!--起源盘-->
                    <el-select v-model="value" filterable placeholder='请选择'>
                        <el-option v-for="item in arrProp17" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        </el-option>
                    </el-select>
                    <div>
                        <el-divider></el-divider>
                        <el-row>
                            <!--品质-->
                            <el-col :lg="8"><div>品质:</div></el-col>
                            <el-col>
                                <el-select v-model="plateQuality" filterable default-first-option placeholder='请选择' value="" @change="plateQualityChange">
                                    <el-option v-for="item in plateQualities" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <div v-if="plateQuality===-1">
                                <el-col :lg="8"><div>{{$t('plate.3')}}:</div></el-col>
                                <el-col>
                                    <el-select v-model="editPlateQuality" filterable default-first-option placeholder='请选择' value="">
                                        <el-option v-for="item in plateQualities" :key="item.value" :label="item.label" :value="item.value" :disabled = "item.value===-1||item.value===0">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col>
                                    配置权重:
                                </el-col>
                                <el-input-number v-model="editPlateQualityChance" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                                <el-button @click="addPlateQualityCustomizeTags">添加权重</el-button>
                                <el-row>
                                    <el-col>
                                        结果集:
                                    </el-col>
                                    <el-tag v-for="(tag,idx) in plateQualityCustomizeTags" :key="idx" closable @close="deletePlateQualityCustomizeTags(idx)">{{$t(tag.data.label)}}-{{tag.chance}}</el-tag>
                                </el-row>
                            </div>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row>
                            <!-- 重量 -->
                            <el-col :lg="8">
                                <div>{{$t('plate.1')}}:</div>
                            </el-col>
                            <el-col v-if="plateQuality === -1">
                                <el-select v-model="plateWeight" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in plateWeights[0]" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col v-if="plateQuality === 1">
                                <el-select v-model="plateWeight" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in plateWeights[1]" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col v-if="plateQuality === 2">
                                <el-select v-model="plateWeight" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in plateWeights[2]" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col v-if="plateQuality === 3">
                                <el-select v-model="plateWeight" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in plateWeights[3]" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col v-if="plateQuality === 4 || plateQuality === 0">
                                <el-select v-model="plateWeight" filterable default-first-option placeholder='请选择' value="">
                                    <el-option v-for="item in plateWeights[4]" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row>
                            <!-- 技能数量 -->
                            <el-col :lg="8">
                                <div>{{$t('plate.2')}}:</div>
                            </el-col>
                            <el-col>
                                <el-select v-model="plateSkillNum" filterable default-first-option placeholder='请选择' value=0>
                                    <el-option v-for="item in plateSkillNumOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row v-if="plateSkillNum===1||plateSkillNum===2">
                            <el-col>技能1：</el-col>
                            <el-select v-model="plateConfigOption1" filterable default-first-option placeholder='请选择' value="">
                                <el-option v-for="item in plateConfigOptions" :key="item.value" :label="$t(item.label)" :value="item.value" :disabled="item.value===-1">
                                </el-option>
                            </el-select>
                            <div v-if="plateConfigOption1===1">
                                <el-col>
                                    选择技能效果:
                                </el-col>
                                <el-select v-model="plateConfig1" filterable placeholder='请选择' value="">
                                    <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div v-if="plateConfigOption1===2">
                                <div>
                                    <el-col>
                                        选择技能效果:
                                    </el-col>
                                    <el-select v-model="plateConfig1" filterable placeholder='请选择' value="">
                                        <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-col>
                                        配置权重:
                                    </el-col>
                                    <el-input-number v-model="editPlateChance1" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                                </div>
                                <el-button @click="addPlateCustomizeTags1">添加权重</el-button>
                                <div>
                                    <el-col>
                                        结果集:
                                    </el-col>
                                    <el-tag v-for="(tag,idx) in plateCustomizeTags1" :key="idx" closable @close="deletePlateCustomizeTags1(idx)">{{$t(tag.data.name)}}-{{tag.chance}}</el-tag>
                                </div>
                            </div>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row v-if="plateSkillNum===2">
                            <el-col>技能2：</el-col>
                            <el-select v-model="plateConfigOption2" filterable default-first-option placeholder='请选择' value="">
                                <el-option v-for="item in plateConfigOptions" :key="item.value" :label="$t(item.label)" :value="item.value">
                                </el-option>
                            </el-select>
                            <div v-if="plateConfigOption2===1">
                                <el-col>
                                    选择技能效果:
                                </el-col>
                                <el-select v-model="plateConfig2" filterable placeholder='请选择' value="">
                                    <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div v-if="plateConfigOption2===2">
                                <div>
                                    <el-col>
                                        选择技能效果:
                                    </el-col>
                                    <el-select v-model="plateConfig2" filterable placeholder='请选择' value="">
                                        <el-option v-for="item in plateConfigs" :key="item.id" :label="$t(item.name)" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div>
                                    <el-col>
                                        配置权重:
                                    </el-col>
                                    <el-input-number v-model="editPlateChance2" :precision="2" :step="0.1" placeholder="请输入权重" ></el-input-number>
                                </div>
                                <el-button @click="addPlateCustomizeTags2">添加权重</el-button>
                                <div>
                                    <el-col>
                                        结果集:
                                    </el-col>
                                    <el-tag v-for="(tag,idx) in plateCustomizeTags2" :key="idx" closable @close="deletePlateCustomizeTags2(idx)">{{$t(tag.data.name)}}-{{tag.chance}}</el-tag>
                                </div>
                            </div>
                        </el-row>
                    </div>
            </el-form-item>

            <el-form-item label="进化光谱编号:" v-if="optionValue == '19'">
                <el-select v-model="value" filterable default-first-option placeholder='进化光谱'>
                    <el-option v-for="item in arr19" :key="item.id + 70000" :label="(item.id + 70000) +'-' + $t(item.name) + '的进化光谱'"
                               :value="item.id + 70000">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+(item.id + 70000)+'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>

                        <span style="float: right">{{ $t(item.name) + '的进化光谱' }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="聊天框:" v-if="optionValue == '20'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr20" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="战斗框:" v-if="optionValue == '21'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr21" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="元核碎片:" v-if="optionValue == '22'">
                <el-select v-model="value" filterable default-first-option placeholder='请选择'>
                    <el-option v-for="item in arr22" :key="item.id " :label="(item.id ) +'-' + $t(item.name)" :value="item.id ">
                        <el-image style="width: 30px; height: 30px; float: left"
                                  :src="'./static/item_icon/'+item.id +'.png'"
                                  fit="cover">
                            <div slot="error" class="image-slot">
                                <el-image style="width: 30px; height: 30px; float: left"
                                          :src="'./static/item_icon/0.png'"
                                          fit="cover">
                                </el-image>
                            </div>
                        </el-image>
                        <span style="float: right">{{ $t(item.name) }}</span>
                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item label='谨慎开关：'>
                <el-switch v-model="isDetail" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-form-item>
            <el-form-item label='数量：'>
                <template v-if="isDetail === false">
                    <el-input-number v-model.number="count1" :min="1" :max="100000000" />
                    <span>快捷选项：</span>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 100) : (count1 = count1 + 100)">一百</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 1000) : (count1 = count1 + 1000)">一千</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 10000) : (count1 = count1 + 10000)">一万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 100000) : (count1 = count1 + 100000)">十万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 1000000) : (count1 = count1 + 1000000)">百万</el-button>
                    <el-button size="mini" @click="count1 === 1 ? (count1 = 10000000) : (count1 = count1 + 10000000)">千万</el-button>
                </template>

                <template v-if="isDetail === true">
                    <el-input-number v-model="num.h" :min="0" :max="10"  placeholder='请输入千万位'></el-input-number>
                    <span>千万</span>
                    <el-input-number v-model="num.g" :min="0" :max="9" placeholder='请输入百万位'></el-input-number>
                    <span>百万</span>
                    <el-input-number v-model="num.f" :min="0" :max="9" placeholder='请输入十万位'></el-input-number>
                    <span>十万</span>
                    <el-input-number v-model="num.e" :min="0" :max="9" placeholder='请输入万位'></el-input-number>
                    <span>万</span>
                    <el-input-number v-model="num.d" :min="0" :max="9" placeholder='请输入千位'></el-input-number>
                    <span>千</span>
                    <el-input-number v-model="num.c" :min="0" :max="9" placeholder='请输入百位'></el-input-number>
                    <span>百</span>
                    <el-input-number v-model="num.b" :min="0" :max="9" placeholder='请输入十位'></el-input-number>
                    <span>十</span>
                    <el-input-number v-model="num.a" :min="0" :max="9" placeholder='请输入个位'></el-input-number>
                    <span>个</span>
                </template>
            </el-form-item>
            <el-form-item label='生成数量预览:'>
                <template v-if="isDetail == true">
                    {{num.a*1 + num.b*10 + num.c*100  + num.d*1000 + num.e*10000 + num.f*100000 + num.g*1000000 + num.h*10000000 }}
                    （
                    <template v-if="num.h >= 0">{{num.h }}千万</template>
                    <template v-if="num.g >= 0">{{num.g }}百万</template>
                    <template v-if="num.f >= 0">{{num.f }}十万</template>
                    <template v-if="num.e >= 0">{{num.e }}万 </template>
                    <template v-if="num.d >= 0">{{num.d }}千 </template>
                    <template v-if="num.c >= 0">{{num.c }}百 </template>
                    <template v-if="num.b >= 0">{{num.b }}十 </template>
                    <template v-if="num.a >= 0">{{num.a }}个 </template>
                    ）
                </template>
                <template v-if="isDetail === false">
                    {{count1}}
                    （
                    <template v-if="count1 >= 10000000"> {{parseInt((count1 % 100000000) / 10000000) }}千万 </template>
                    <template v-if="count1 >= 1000000"> {{parseInt((count1 % 10000000) / 1000000) }}百万 </template>
                    <template v-if="count1 >= 100000"> {{parseInt((count1 % 1000000) / 100000) }}十万 </template>
                    <template v-if="count1 >= 10000"> {{parseInt((count1 % 100000) / 10000) }}万 </template>
                    <template v-if="count1 >= 1000"> {{parseInt((count1 % 10000) / 1000) }}千 </template>
                    <template v-if="count1 >= 100"> {{parseInt((count1 % 1000) / 100) }}百 </template>
                    <template v-if="count1 >= 10"> {{parseInt((count1 % 100) / 10) }}十 </template>
                    {{parseInt(count1 % 10) }}个
                    ）
                </template>
            </el-form-item>
        </el-form>
        <el-form>
            <el-button @click="generateReward">添加奖励</el-button>
        </el-form>

        <!--<el-form v-if="finalArr.length > 0">-->
            <!--<div>{{$t("reward_editor.29")}}:</div>-->
            <!--<el-tag v-for="(tag,idx) in finalArr" :key="idx" closable @close="handleClose(idx)" :type="tag">-->
                <!--{{tag}}-->
            <!--</el-tag>-->
            <!--<div>{{$t("reward_editor.30")}}：{{finalValue}}</div>-->
        <!--</el-form>-->
    </el-card>
</template>

<script>
    import commonApi from '../service/common_api.js'
    import {
        mapState
    } from "vuex";

    export default {
        name: "common_editor",
        data() {
            return {
                optionValue: '0',
                num: {
                    a: 0,
                    b: 0,
                    c: 0,
                    d: 0,
                    e: 0,
                    f: 0,
                    g: 0,
                    h: 0,
                },
                isDetail: false,
                options: [
                    {
                        value: '0',
                        label: '必要资源'
                    },
                    {
                        value: '1',
                        label: '怪兽'
                    },
                    {
                        value: '2',
                        label: '怪兽碎片'
                    },
                    {
                        value: '3',
                        label: '材料/道具'
                    },
                    {
                        value: '4',
                        label: '元核'
                    },
                    {
                        value: '6',
                        label: '觉醒结晶'
                    },
                    {
                        value: '7',
                        label: '战纹'
                    },
                    {
                        value: '8',
                        label: '觉醒结晶碎片'
                    },
                    {
                        value: '9',
                        label: '部落公共资源'
                    },
                    {
                        value: '10',
                        label: '回复类道具'
                    },
                    {
                        value: '11',
                        label: '头像'
                    },
                    {
                        value: '12',
                        label: '头像框'
                    },
                    {
                        value: '13',
                        label: '宝箱'
                    },
                    {
                        value: '14',
                        label: '皮肤'
                    },
                    {
                        value: '15',
                        label: '时效类道具'
                    } ,
                    {
                        value: '17',
                        label: '起源盘'
                    },
                    {
                        value: '19',
                        label: '进化光谱'
                    },
                    {
                        value: '20',
                        label: '聊天框'
                    } ,
                    {
                        value: '21',
                        label: '战斗框'
                    } ,
                    {
                        value: '22',
                        label: '元核碎片'
                    }

                ],
                monsterConfigs: [],
                propConfig: [],
                emblemEffectConfig: [],
                godConfigs: [],
                wallGainType: [],
                skinGainType: [],
                arr0: [],
                arr3: [],
                arr5: [],
                arr7: [],
                arr8: [],
                arr9: [],
                arr10: [],
                arr11: [],
                arr12: [],
                arr13: [],
                arr14: [],
                arr15: [],
                arr19: [],
                arr20: [],
                arr21: [],
                arr22: [],
                arrProp17: [],
                arrProp4: [],
                countSwitch: false,
                rateSwitch: false,
                value: '',
                count1: 1,
                count2: 1,
                rate: 0.1,
                finalArr: [],
                finalValue: '',
                emblemMainConfigs: [],
                emblemFateConfigs: [],
                emblemEntryConfigs: [],
                emblemRandomByQuality:false,
                emblemMainProperty: 1,
                emblemFateProperty: 1,
                emblemLevel: 1,
                emblemStage: 1,
                emblemQuality: 1,
                emblemFateOptions:[{
                    value: 0,
                    label: '按配置随机属性'
                },{
                    value: 2,
                    label: '必出指定属性',
                },{
                    value: 3,
                    label: '自定义概率'
                },{
                    value: -1,
                    label: '必定不出'
                }],
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                editEmblemFateChance:0,
                editEmblemFateProperty: 51,
                emblemFateSwitch: false,
                emblemQualities: [{
                        value: 0,
                        label: '按配置随机属性'
                    },{
                        value: 1,
                        label: '白'
                    },
                    {
                        value: 2,
                        label: '绿'
                    },
                    {
                        value: 3,
                        label: '蓝'
                    },
                    {
                        value: 4,
                        label: '紫'
                    },
                    {
                        value: 5,
                        label: '橙'
                    },
                    {
                        value: 6,
                        label: '红'
                    }
                ],
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        rdFloat:0,
                        active:false
                    },
                ],
                emblemEntry1: [-1, -1],
                emblemEntry2: [-1, -1],
                emblemEntry3: [-1, -1],
                emblemEntry4: [-1, -1],
                emblemEntry5: [-1, -1],
                emblemEntry6: [-1, -1],
                emblemEntrySwitch1: false,
                emblemEntrySwitch2: false,
                emblemEntrySwitch3: false,
                emblemEntrySwitch4: false,
                emblemEntrySwitch5: false,
                emblemEntrySwitch6: false,

                wallGainQualityConfig: [
                    {id: 0,name: "白"},
                    {id: 1,name: "绿"},
                    {id: 2,name: "蓝"},
                    {id: 3,name: "紫"},
                    {id: 4,name: "橙"},
                    {id: 5,name: "红"},
                    {id: 100,name: "随机品质"}
                ],
                warGrooveQuality:0,
                warGrooveChannelSwitch: false,
                warGrooveChannelUp: 0,
                warGrooveChannelDown: 0,
                warGrooveChannelLeft: 0,
                warGrooveChannelRight: 0,
                warGrooveChannelOption: [
                    {id: 0,name: "不通"},
                    {id: 1,name: "通"},
                ],

                plateQuality:1,
                editPlateQuality:1,
                plateWeight:0,
                plateSkillNum:0,
                plateConfig1:0,
                plateConfigOption1:0,
                editPlateChance1:0,
                plateCustomizeTags1:[],
                plateConfig2:0,
                plateConfigOption2:0,
                editPlateChance2:0,
                plateCustomizeTags2:[],
                editPlateQualityChance:0,
                plateQualityCustomizeTags:[],
                plateConfigs:[],
                plateQualities:[
                    {value: -1,label: "自定权重"},
                    {value: 0,label: "随机品质"},
                    {value: 1,label: "蓝"},
                    {value: 2,label: "紫"},
                    {value: 3,label: "橙"},
                    {value: 4,label: "红"}
                ],
                plateSkillNumOptions:[
                    {
                        value: 0,
                        label:"随机"
                    },
                    {
                        value: 1,
                        label:"单技能"
                    },
                    {
                        value: 2,
                        label:"双技能"
                    },

                ],
                plateWeights:{
                    0:[
                        {value: 0,label: "随机重量"},
                        {value: 3,label: "重量三"},
                        {value: 4,label: "重量四"},
                        {value: 5,label: "重量五"},
                        {value: 6,label: "重量六"},
                        {value: 7,label: "重量七"}
                    ],
                    1:[
                        {value: 0,label: "随机重量"},
                        {value: 3,label: "重量三"},
                        {value: 4,label: "重量四"}
                    ],
                    2:[
                        {value: 0,label: "随机重量"},
                        {value: 4,label: "重量四"},
                        {value: 5,label: "重量五"}
                    ],
                    3:[
                        {value: 0,label: "随机重量"},
                        {value: 5,label: "重量五"},
                        {value: 6,label: "重量六"}
                    ],
                    4:[
                        {value: 0,label: "随机重量"},
                        {value: 5,label: "重量五"},
                        {value: 7,label: "重量七"}
                    ],
                },
                plateConfigOptions:[
                    {
                        value: 0,
                        label:"随机"
                    },
                    {
                        value: 1,
                        label:"指定"
                    },
                    {
                        value: 2,
                        label:"自定义"
                    },
                    {
                        value: -1,
                        label:"必不出"
                    },
                ],

                optionMap:{
                    '0':'必要资源',
                    '1':'怪兽',
                    '2':'怪兽碎片',
                    '3':'材料/道具',
                    '4':'元核',
                    '5':'约束性道具',
                    '6':'觉醒结晶',
                    '7':'战纹',
                    '8':'觉醒结晶碎片',
                    '9':'部落公共资源',
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '16':'部落头像',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
            }
        },
        props: ['mailTemplateRewards', 'currentReward', 'currentRewardIdx'],
        watch: {
            mailTemplateRewards(n, l) {
                if (this.mailTemplateRewards !== undefined) {
                    this.resolveRewardStr(this.mailTemplateRewards.split(',')[0]);
                }
            },
            optionValue(n, l) {
                if (n!==l) {
                    this.value = '';
                }
            },
            currentReward(n, l) {
                if (n!==l) {
                    if (this.mailTemplateRewards !== undefined) {
                        this.resolveRewardStr(this.currentReward.length>0?this.currentReward:this.mailTemplateRewards.split(',')[0]);
                    }

                }
            },
            currentRewardIdx(n, l) {
                if (n!==l) {
                    if (this.mailTemplateRewards !== undefined) {
                        this.resolveRewardStr(this.currentReward.length>0?this.currentReward:this.mailTemplateRewards.split(',')[0]);
                    }
                }
            }
        },
        created() {
            this.initData();
        },
        mounted() {
            if (this.mailTemplateRewards !== undefined && this.mailTemplateRewards !== '') {
                this.resolveRewardStr(this.mailTemplateRewards.split(',')[0]);
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        methods: {
            initData: function() {
                let self = this;
                let tables = 'monster_config,war_groove_config,skin_config,god_config,emblem_effect_config,prop_config,plate_origin_config';
                commonApi.getConfs({
                    tables: tables
                }).then(res => {
                    self.monsterConfigs = [];
                    self.propConfig = res.prop_config;
                    self.emblemEffectConfig = res.emblem_effect_config;
                    self.godConfigs = res.god_config;
                    self.wallGainType = res.war_groove_config;
                    self.skinGainType = res.skin_config;

                    res.monster_config.forEach(configItem=>{
                        if (configItem.special === 0){
                            self.monsterConfigs.push(configItem);
                        }
                    })


                    let arr0 = [];
                    let arr3 = [];
                    let arr9 = [];
                    let arr10 = [];
                    let arr11 = [];
                    let arr12 = [];
                    let arr13 = [];
                    let arr14 = [];
                    let arr15 = [];
                    let arr20= [];
                    let arr21 = [];
                    let arr22 = [];
                    let arrProp17 = [];
                    let arrProp4 = [];
                    res.prop_config.forEach(function(item) {
                        let type = item.big_type;
                        if (type === 0) {
                            arr0.push(item);
                        } else if (type === 3) {
                            arr3.push(item);
                        } else if(type === 9){
                            arr9.push(item);
                        } else if(type === 4){
                            arrProp4.push(item);
                        } else if (type === 10) {
                            arr10.push(item)
                        } else if (type === 11) {
                            arr11.push(item)
                        } else if (type === 12) {
                            arr12.push(item)
                        } else if (type === 13) {
                            arr13.push(item)
                        } else if (type === 14) {
                            arr14.push(item)
                        } else if (type === 15) {
                            arr15.push(item)
                        } else if (type === 17){
                            arrProp17.push(item)
                        } else if (type === 20){
                            arr20.push(item)
                        } else if (type === 21){
                            arr21.push(item)
                        } else if (type === 22){
                            arr22.push(item)
                        }
                    });
                    self.arr0 = arr0;
                    self.arr3 = arr3;
                    self.arr9 = arr9;
                    self.arr10 = arr10;
                    self.arr11 = arr11;
                    self.arr12 = arr12;
                    self.arr13 = arr13;
                    self.arr14 = arr14;
                    self.arr15 = arr15;
                    self.arr20 = arr20;
                    self.arr21 = arr21;
                    self.arr22 = arr22;
                    self.arrProp17 = arrProp17;
                    self.arrProp4 = arrProp4;
                    //元核属性类型: 0-主属性;1-二字词条;2-四字词条;3-宿命
                    let tw = {
                        value: 1,
                        label: '二字词条',
                        children: []
                    };
                    let fw = {
                        value: 2,
                        label: '四字词条',
                        children: []
                    };
                    let special = {
                        value: 3,
                        label: '特殊',
                        children: [{
                            value: 0,
                            label: '按配置随机属性',
                        }]
                    }
                    let twConfigs = [];
                    let fwConfigs = [];
                    res.emblem_effect_config.forEach(function(item) {
                        if (item.type === 0) {
                            self.emblemMainConfigs.push(item);
                        } else if (item.type === 1) {
                            twConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type === 2) {
                            fwConfigs.push({
                                value: item.id,
                                label: self.$t(item.name) + '('+self.$t(item.description)+')'
                            });
                        } else if (item.type === 3) {
                            self.emblemFateConfigs.push(item);
                        }
                    });
                    tw.children = twConfigs;
                    fw.children = fwConfigs;
                    self.emblemEntryConfigs.push(tw);
                    self.emblemEntryConfigs.push(fw);
                    self.emblemEntryConfigs.push(special);
                    self.arr9 = arr9;

                    let arr5 = [];
                    let arr8 = [];
                    let arr19 = [];
                    self.monsterConfigs.forEach(function(item) {
                        let quality = item.quality;
                        let race = item.race;
                        let hyperEvolution = item.hyper_evolution;
                        // console.log(quality,race);
                        if (quality === 4 && race.indexOf("_")>-1) {
                            arr5.push(item);
                            arr8.push(item);
                        }
                        if (hyperEvolution ===1){
                            arr19.push(item);
                        }
                    });
                    self.arr5 = arr5;
                    self.arr8 = arr8;
                    self.arr19 = arr19;

                    let arr7 = [];
                    res.war_groove_config.forEach(function(item) {
                        let type = item.type;
                        if (type === 3 || type === 4) {
                            arr7.push(item);
                        }
                    });
                    self.arr7 = arr7;

                    res.plate_origin_config.forEach(function(item) {
                        self.plateConfigs.push({
                            id: item.id,
                            name: self.$t(item.name) + '('+self.$t(item.description)+')'
                        });
                    });

                    //self.glyphFateType = arr2;
                })
            },
            handleClose(idx) {
                console.log(idx)
                let self = this;
                self.finalArr.splice(idx, 1);
                self.finalValue = self.finalArr.join(",");
            },

            generateReward() {
                let self = this;

                if (self.value == '') {
                    this.$message({
                        type: 'info',
                        message: '请选择编号'
                    })
                    return;
                }

                //条件串
                let conditionValue = '';

                //元核
                if (self.optionValue == 4) {
                    let emblemStr = "";
                    if(self.value == 50001){
                        emblemStr = self.emblemLevel + "_" + self.emblemStage + "_" + self.emblemQuality;
                        if (self.emblemFate == 0) {
                            emblemStr = emblemStr + "_" +self.emblemFate + "_-1";
                        }else if(self.emblemFate == 2) {
                            emblemStr = emblemStr + "_" + self.emblemFateProperty + "_1";
                        }else if(self.emblemFate == 3){
                            let temp = "";
                            if(self.emblemFateCustomizeTags.length>0){
                                for(let i = 0 ;i<self.emblemFateCustomizeTags.length;i++){
                                    let item = self.emblemFateCustomizeTags[i];
                                    temp = temp + item.id+"@"+item.chance+"@"+item.quality+"@"+item.rdFloat+"#";
                                }
                                temp = temp.slice(0,temp.length-1);
                            }else{
                                temp = "0";
                            }

                            emblemStr = emblemStr + "_" + temp + "_" + self.emblemFateCustomize/100;
                        }else if(self.emblemFate == -1){
                            emblemStr = emblemStr + "_" +self.emblemFate + "_-1";
                        }
                        emblemStr = emblemStr + "_" + self.emblemMainProperty+ "_";
                        //
                        for(let i=0;i<self.editEmblemEntries.length;i++){
                            let current = self.editEmblemEntries[i];
                            if(current.active === true){
                                emblemStr = emblemStr + current.entry[1] + "@" + current.quality+ "@" + current.rdFloat +"#";
                            }else{
                                emblemStr = emblemStr + "0#";
                            }
                        }
                        emblemStr = emblemStr.substr(0,emblemStr.length-1);
                    }
                    conditionValue = emblemStr;
                } else if(self.optionValue == 7){
                    if (self.warGrooveChannelSwitch) {
                        conditionValue = self.warGrooveQuality + '_' + self.warGrooveChannelUp + '_' + self.warGrooveChannelDown + '_' + self.warGrooveChannelLeft + '_' + self.warGrooveChannelRight
                    } else {
                        conditionValue = self.warGrooveQuality + '';
                    }
                } //起源盘
                else if(self.optionValue == 17){
                    let plateStr = "";
                    if(self.plateQuality===-1){
                        let temp = "";

                        if(self.plateQualityCustomizeTags.length>0){
                            for(let i = 0 ;i<self.plateQualityCustomizeTags.length;i++){
                                let item = self.plateQualityCustomizeTags[i];
                                temp = temp + item.value+"@"+item.chance+"#";
                            }
                            temp = temp.slice(0,temp.length-1);
                        }else{
                            temp = "0";
                        }
                        plateStr = temp;
                    }else{
                        plateStr = self.plateQuality
                    }

                    plateStr = plateStr + "_" + self.plateWeight+"_"+self.plateSkillNum;

                    if(self.plateSkillNum>0){
                        if(self.plateSkillNum===1){
                            if(self.plateConfigOption1 === 2){
                                let temp = "";

                                if(self.plateCustomizeTags1.length>0){
                                    for(let i = 0 ;i<self.plateCustomizeTags1.length;i++){
                                        let item = self.plateCustomizeTags1[i];
                                        temp = temp + item.id+"@"+item.chance+"#";
                                    }
                                    temp = temp.slice(0,temp.length-1);
                                }else{
                                    temp = "0";
                                }
                                plateStr = plateStr + "_" +temp;
                            }else {
                                plateStr = plateStr + "_" +self.plateConfig1;
                            }

                            plateStr = plateStr + "_0";
                        }else if(self.plateSkillNum===2){
                            if(self.plateConfigOption1 === 2){
                                let temp = "";

                                if(self.plateCustomizeTags1.length>0){
                                    for(let i = 0 ;i<self.plateCustomizeTags1.length;i++){
                                        let item = self.plateCustomizeTags1[i];
                                        temp = temp + item.id+"@"+item.chance+"#";
                                    }
                                    temp = temp.slice(0,temp.length-1);
                                }else{
                                    temp = "0";
                                }
                                plateStr = plateStr + "_" +temp;
                            }else {
                                plateStr = plateStr + "_" +self.plateConfig1;
                            }
                            if(self.plateConfigOption2 === 2){
                                let temp = "";
                                if(self.plateCustomizeTags2.length>0){
                                    for(let i = 0 ;i<self.plateCustomizeTags2.length;i++){
                                        let item = self.plateCustomizeTags2[i];
                                        temp = temp + item.id+"@"+item.chance+"#";
                                    }
                                    temp = temp.slice(0,temp.length-1);
                                }else{
                                    temp = "0";
                                }
                                plateStr = plateStr + "_" +temp;
                            }else {
                                plateStr = plateStr + "_" +self.plateConfig2;
                            }
                        }

                    }else {
                        plateStr = plateStr + "_0_0";
                    }

                    conditionValue = plateStr;
                }

                //数量串
                let finalCount = '';
                if (self.isDetail) {
                    finalCount = self.num.a * 1 + self.num.b * 10 + self.num.c * 100 + self.num.d * 1000 + self.num
                        .e * 10000 + self.num.f * 100000 + self.num.g * 1000000 + self.num.h * 10000000;
                } else {
                    finalCount = self.count1
                }


                let finalContent = self.optionValue + "$" + self.value + "_" + finalCount;

                if (conditionValue != '') {
                    finalContent = finalContent + "_" + conditionValue;
                }

                //概率串
                if (self.rateSwitch) {
                    finalContent = finalContent + "|" + self.rate;
                }

                //拼接
                // self.finalArr.push(finalContent);
                //
                // self.finalValue = self.finalArr.join(",");

                let optionValueCN = self.optionMap[self.optionValue];


                let idCn = self.getIdCn(self.optionValue,self.value);

                let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;

                this.$emit('reward', finalContent, this.currentRewardIdx, finalContentCN)

                // console.log(self.finalValue)
                // self.$emit('rewards', self.finalValue)
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" ||
                    optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"||
                    optionValue == "20" || optionValue == "21" || optionValue == "22"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }else if(optionValue == "19"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-70000)) + "的进化光谱";
                }
            },

            addEmblemEntry() {
                let self = this;
                if (self.emblemEntrySwitch1 === false) {
                    self.emblemEntrySwitch1 = true;
                    return;
                }
                if (self.emblemEntrySwitch2 === false) {
                    self.emblemEntrySwitch2 = true;
                    return;
                }
                if (self.emblemEntrySwitch3 === false) {
                    self.emblemEntrySwitch3 = true;
                    return;
                }
                if (self.emblemEntrySwitch4 === false) {
                    self.emblemEntrySwitch4 = true;
                    return;
                }
                if (self.emblemEntrySwitch5 === false) {
                    self.emblemEntrySwitch5 = true;
                    return;
                }
                if (self.emblemEntrySwitch6 === false) {
                    self.emblemEntrySwitch6 = true;
                    return;
                }
            },
            removeEmblemEntry() {
                let self = this;
                if (self.emblemEntrySwitch6 === true) {
                    self.emblemEntrySwitch6 = false;
                    return;
                }
                if (self.emblemEntrySwitch5 === true) {
                    self.emblemEntrySwitch5 = false;
                    return;
                }
                if (self.emblemEntrySwitch4 === true) {
                    self.emblemEntrySwitch4 = false;
                    return;
                }
                if (self.emblemEntrySwitch3 === true) {
                    self.emblemEntrySwitch3 = false;
                    return;
                }
                if (self.emblemEntrySwitch2 === true) {
                    self.emblemEntrySwitch2 = false;
                    return;
                }
                if (self.emblemEntrySwitch1 === true) {
                    self.emblemEntrySwitch1 = false;
                    return;
                }
            },
            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }else if(self.optionValue === '17'){
                                let skillArray = element.split("#");
                                if(skillArray.length>=1 && skillArray[0].split("@").length>1){
                                    self.plateConfigOption1 = 2;
                                    for (let i = 0; i < skillArray.length; i++) {
                                        let item = skillArray[i].split("@");
                                        for(let j=0;j<self.plateConfigs.length;j++){
                                            if(self.plateConfigs[j].id===parseInt(item[0])){
                                                self.plateCustomizeTags1[i] = {id:item[0],chance:item[1],data:self.plateConfigs[j]}
                                            }
                                        }
                                    }

                                }else{
                                    if(element>0){
                                        self.plateConfigOption1 = 1;
                                        self.plateConfig1 = parseInt(element);
                                    }
                                }
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },
            onEmblemTypeChange(){
                let self = this;
                if(self.value==50001){
                    self.emblemRandomByQuality = false;
                }else{
                    self.emblemRandomByQuality = true;
                }
            },
            onEmblemQualityChange(){
                let self = this;
                let quality = self.emblemQuality;

                for(let i=0;i<self.editEmblemEntries.length;i++){
                    if(i<quality){
                        self.editEmblemEntries[i].active = true;
                    }else{
                        self.editEmblemEntries[i].active = false;
                    }
                }
            },
            //元核等级变化
            onEmblemLevelChange(){
                let self = this;
                let level = self.emblemLevel;
                self.emblemStage = Math.floor(level / 5);
            },
            addEmblemFateChance(){
                let self = this;
                let temp;
                for(let i=0;i<self.emblemFateConfigs.length;i++){
                    if(self.emblemFateConfigs[i].id==self.editEmblemFateProperty){
                        temp = self.emblemFateConfigs[i];
                    }
                }
                self.emblemFateCustomizeTags.push({id:self.editEmblemFateProperty,data:temp,chance:self.editEmblemFateChance});
            },
            deleteEmblemFateChance(idx){
                let self = this;
                self.emblemFateCustomizeTags.splice(idx,1);
            },
            //起源盘相关方法
            addPlateCustomizeTags1(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateConfigs.length;i++){
                    if(self.plateConfigs[i].id===self.plateConfig1){
                        temp = self.plateConfigs[i];
                    }
                }
                self.plateCustomizeTags1.push({id:self.plateConfig1,data:temp,chance:self.editPlateChance1});
            },
            deletePlateCustomizeTags1(idx){
                let self = this;
                self.plateCustomizeTags1.splice(idx,1);
            },
            addPlateCustomizeTags2(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateConfigs.length;i++){
                    if(self.plateConfigs[i].id===self.plateConfig2){
                        temp = self.plateConfigs[i];
                    }
                }
                self.plateCustomizeTags2.push({id:self.plateConfig2,data:temp,chance:self.editPlateChance2});
            },
            deletePlateCustomizeTags2(idx){
                let self = this;
                self.plateCustomizeTags2.splice(idx,1);
            },
            plateQualityChange(){
                this.plateWeight = 0;
            },
            addPlateQualityCustomizeTags(){
                let self = this;
                let temp;
                for(let i=0;i<self.plateQualities.length;i++){
                    if(self.plateQualities[i].value===self.editPlateQuality){
                        temp = self.plateQualities[i];
                    }
                }
                self.plateQualityCustomizeTags.push({value:self.editPlateQuality,data:temp,chance:self.editPlateQualityChance});
            },
            deletePlateQualityCustomizeTags(idx){
                let self = this;
                self.plateQualityCustomizeTags.splice(idx,1);
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common_editor.vue